import React from 'react';
import { Box, Grid, useTheme } from '@mui/material';

import { ScenarioChartCard } from './ScenarioChartCard';
import { useScenariosQueries } from '../hooks/useScenariosQueries';
import { DateRangePickerValue } from 'ui/MuiDateRangePicker';

interface ReviewsByScenarioSectionProps {
    dateRange: DateRangePickerValue;
    selectedLocationIds: string[];
}

export function ReviewsByScenarioSection({ dateRange, selectedLocationIds }: ReviewsByScenarioSectionProps) {
    const theme = useTheme();
    const [avgPlatform, setAvgPlatform] = React.useState<string>('all');
    const [countPlatform, setCountPlatform] = React.useState<string>('all');

    const { averageScenariosData, countScenariosData } = useScenariosQueries(
        avgPlatform,
        countPlatform,
        dateRange,
        selectedLocationIds
    );

    return (
        <Box mt={3}>
            <Grid container spacing={3}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <ScenarioChartCard
                        title="Total Ratings by Scenario"
                        subtitle="Number of ratings per ordering scenario"
                        data={countScenariosData.data}
                        color={theme.palette.purple.core}
                        loading={countScenariosData.loading}
                        platform={countPlatform}
                        onPlatformChange={setCountPlatform}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <ScenarioChartCard
                        title="Avg Rating by Scenario"
                        subtitle="Average star rating per ordering scenario"
                        data={averageScenariosData.data}
                        color={theme.palette.purple.secondary}
                        maxValue={5}
                        stepSize={1}
                        loading={averageScenariosData.loading}
                        platform={avgPlatform}
                        onPlatformChange={setAvgPlatform}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}
